import { Box } from 'grommet'
import styled from 'styled-components'
import { tablet } from '../../../../../common/assets/utils/_breakpoints'
import { Card, Heading, Text } from '../../../../../legacy-lib/design-kit-ui'
import { gray } from '../../../../../legacy-lib/design-kit-ui/Palette'

export const CardTitleHeadingStyle = styled(Heading)`
  color: ${gray.spanish};
  font-size: 18px;
  margin: 0;
  font-weight: 500;
  letter-spacing: -0.45px;
  line-height: 22px;
`

export const TextStyle = styled(Text)`
  font-size: ${(props: any) => (props.size ? props.size : '14px')};
  font-weight: ${(props: any) => (props.bold ? '500' : 'normal')};
  letter-spacing: 0;
  line-height: 16px;

  @media (min-width: ${tablet}) {
    font-weight: ${(props: any) => (props.bold ? '500' : '300')};
  }
`

export const SmallTextStyle = styled(Text)`
  font-size: 12px;
  letter-spacing: 0;
  line-height: 14px;
  font-weight: 300;

  @media (min-width: ${tablet}) {
    margin-top: 10px;
    line-height: 12px;
    font-weight: normal;
    color: ${gray.dim};
  }
`

export const NumberBoxMobileStyle = styled(Box)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`

export const SmallCardStyle = styled(Card)`
  height: 108px;
  border: none;
  padding-bottom: 4px;
  width: 100%;
  margin: 0;

  > div {
    &.desktop {
      display: none;
    }
  }

  @media (min-width: ${tablet}) {
    height: 184px;
    width: 164px;
    padding-bottom: 20px;
    margin: 8px;

    > div {
      &.desktop {
        display: flex;
      }
      &.is-mobile {
        display: none;
      }
    }
  }
`

export const NumberHeadingStyle = styled(Heading)`
  margin: 0;
  font-size: 56px;
  letter-spacing: -1.4px;
  line-height: 66px;

  @media (min-width: ${tablet}) {
    letter-spacing: -1.5px;
    line-height: 75px;
    font-size: ${(props: any) => (props.size ? props.size : '64px')};
  }
`
